import React, { useState, useEffect, useMemo } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Textarea
} from '@chakra-ui/react';
import './SalesOrder.css';
import { Trash2 } from 'lucide-react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import { createSalesOrders } from '../../../redux/api/salesOrdersApi/salesOrdersApi.js';
import { updatesalesOrdersAction } from '../../../redux/reduxSlice/SalesOrdersSlice.js';
import { addsalesOrdersAction } from '../../../redux/reduxSlice/SalesOrdersSlice.js';
import { updateSalesOrders } from '../../../redux/api/salesOrdersApi/salesOrdersApi.js';
import { getInventory } from '../../../redux/reduxApi/inventoryReduxApi.js';
function SalesForm(props) {
  const { isUpdateMode, dataToEdit, formData: initialFormData, setIsUpdateMode, salesOrdersId, onNewDataAdded } = props;
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [deletedItemRows, setDeletedItemRows] = useState([]);
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const inventoryData = useSelector((state) => state?.inventory?.inventory);
  const companyData = useSelector((state) => state.utils.companyList.map(({ companies }) => ({ ...companies, label: companies?.companyName, value: companies?.ROWID })));
  const employeesData = useSelector((state) => state.employee?.employee.map(({ employees }) => ({ ...employees, label: employees.employeeName, value: employees.ROWID })))
  // const vendorData = useSelector((state) => state.vendor?.vendor.map(({vendor}) => ({ ...vendor, label: vendor?.vendorName || "Unknown Vendor", value: vendor?.ROWID || '' })))
  const vendorData = useSelector((state) => state.utils.vendorList)
  console.log({ "employeesData": employeesData })
  const [formData, setFormData] = useState(
    {
      customerName: "",
      salesOrder: "",
      reference: " ",
      salesOrderDate: "",
      expectedShipmentDate: "",
      workingDays: "",
      deliveryMethod: "",
      salesPerson: "",
      franchiseeAccount: "",
      paymentTerms: "",
      frequency: "",
      soDate: "",
      jobType: "",
      recurringSO: false,
      customerNotes: "",
      items: [],
    });

  const handleOnClose = () => {
    closeDrawer();
    setIsUpdateMode(false)
    setFormData({
      customerName: "",
      salesOrder: "",
      reference: " ",
      salesOrderDate: "",
      expectedShipmentDate: "",
      workingDays: "",
      deliveryMethod: "",
      salesPerson: "",
      franchiseeAccount: "",
      paymentTerms: "",
      frequency: "",
      soDate: "",
      jobType: "",
      recurringSO: false,
      customerNotes: "",
      items: [],
    })
  };





  // const vendorData = useSelector((state) =>
  //   state.utils.vendorList?.map((vendor) => ({
  //     ...vendor, // Spread the vendor object to keep all its properties
  //     label: vendor.vendorName, // Assuming "vendorName" is the field you want to use as the label
  //     value: vendor.ROWID, // Assuming "ROWID" is the field you want to use as the value
  //   }))
  // );

  const setDataToItemTableRowVendor = (vendorOptions) => {
    if (!vendorOptions) return;

    setRows((prevRows) =>
      prevRows.map((row) =>
        row.index === vendorOptions.index // or use another identifier like `ROWID`
          ? { ...row, vendorData: vendorOptions.label, rowId: vendorOptions.value }
          : row
      )
    );
  };



  // Fetch Employees data
  const setDataToItemTableRowEmployees = (option) => {
    if (!option) return;
    setRows((prevRows) => prevRows.map((row, idx) =>
      row.index === option.index ? { ...row, employeesData: option.label || '', rowId: option.ROWID || '', } : row));
  };



  const setDataToItemTableRowCompany = (option) => {
    if (!option) return;
    setRows((prevRows) => prevRows.map((row, idx) =>
      row.index === option.index ? { ...row, companyData: option.label || '', rowId: option.ROWID || '', } : row));
  };


  // Fetch inventory data
  useEffect(() => {
    dispatch(getInventory(1))
      .catch((error) => {
        console.error('Error fetching Inventory data:', error);
      })
      .finally(() => { });
  }, [dispatch]);

  useEffect(() => {
    // Safely map over inventoryData if it's an arrayF
    const temp = Array.isArray(inventoryData)
      ? inventoryData.map(({ inventory }) => ({
        value: inventory.ROWID,
        label: inventory.name,
        ...inventory,
      }))
      : [];
    setInventoryOptions(temp); // Update inventory options
  }, [inventoryData]);

  // Updating row data based on selected item
  const setDataToItemTableRow = (item, index) => {
    if (!item) return;

    setRows((prev) =>
      prev.map((row, idx) =>
        idx === index
          ? {
            ...row,
            inventoryData: item.label || '',
            rowId: item.ROWID || '',
            qty: item.annualQty || 0,
            rate: item.sellingPrice || 0,
            // discount: item.discount || 0, // Set discount to item discount (or 0)
            tax: item.tax || 0,
            // Calculate amount based on discount and rate
            // amount:
            //   item.annualQty * item.sellingPrice -
            //   (item.discount * (item.annualQty * item.sellingPrice)) / 100,
          }
          : row
      )
    );
    setFormData((prev) => ({ ...prev, itemtable: [...rows] }));
  };

  const calculateAmount = (qty, rate, discount) => {
    return qty * rate * (1 - discount / 100);
  };

  const calculateTotal = (amount, tax) => {
    return amount * (1 + tax / 100);
  };

  // Delete row function
  const deleteRow = (index) => {
    setRows((prev) => prev.filter((_, idx) => idx !== index));
    setFormData((prev) => ({ ...prev, itemtable: rows.filter((_, idx) => idx !== index) }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData)
    setShowProgressBar(true)
    createSalesOrders(formData)
      .then((response) => {
        onNewDataAdded()
        console.log("Responseeeeeeeeeeeeeeee - ", response);
        if (response.data.success) {
          const ROWID = response.data.ROWID
          dispatch(addsalesOrdersAction({ ROWID, formData }));
          console.log(response)
          setFormData()
          setShowProgressBar(false)
          toast.success("SalesOrders added successfully!");
          handleOnClose();
          setFormData();
        }
        else {
          toast.error("Unable to add SalesOrders , Please try again!")
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        setShowProgressBar(false)
        toast.error("Failed to add SalesOrders. Please try again.");
      });
  }


  const handelOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    updateSalesOrders(formData, salesOrdersId).then((response) => {
      console.log({ response })
      toast.success("SalesOrders Updated successfully!");
      handleOnClose();
      if (response.data.success) {
        dispatch(updatesalesOrdersAction({ formData, salesOrdersId }))
        console.log("updated")
      }
    }).catch((error) => {
      setShowProgressBar(false);
      console.log({ error })
    }).finally(() => {
      setShowProgressBar(false);
    })
  };

  useEffect(() => {
    console.log({ isUpdateMode }, { dataToEdit })
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...props.dataToEdit,
        itemtable: dataToEdit.items ? [...JSON.parse(dataToEdit.items)] : []
      }
      ))
    }
    console.log(formData)
    if (dataToEdit.items) {
      setRows(JSON.parse(dataToEdit.items))

    }
  }, [isUpdateMode, dataToEdit]);

  // useEffect(() => {
  //   console.log({ isUpdateMode }, { dataToEdit });

  //   if (isUpdateMode && dataToEdit) {
  //     // Check if dataToEdit.items is a valid string before parsing
  //     let parsedItems = [];
  //     if (dataToEdit.items) {
  //       try {
  //         parsedItems = JSON.parse(dataToEdit.items);
  //         if (!Array.isArray(parsedItems)) {
  //           parsedItems = []; // fallback in case the parsed data is not an array
  //         }
  //       } catch (e) {
  //         console.error("Failed to parse items:", e);
  //         parsedItems = []; // fallback in case JSON parsing fails
  //       }
  //     }

  //     setFormData((prev) => ({
  //       ...prev,
  //       ...props.dataToEdit,
  //       itemtable: parsedItems,
  //     }));
  //   }
  // }, [isUpdateMode, dataToEdit, props.dataToEdit]);


  const editId = useMemo(() => {
    return props.editId;
  }, [JSON.stringify(props.editId)]);

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [name]: value }))
  };


  useEffect(() => {
    console.log(formData)
  }, [formData])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Custom style for lookup field
  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
      borderRadius: "20px",
      border: '0.5px solid rgb(196,196,196,0.5) !important'
    }),
  }
  const [customerName, setCustomerName] = useState([])
  const [deliveryMethod, setDeliveryMethod] = useState([])
  const [salesPerson, setSalesPerson] = useState([])
  const [franchiseeAccount, setFranchiseeAccount] = useState([])
  const [itemDetails, setItemDetails] = useState([])

  const { closeDrawer } = props;

  const [rows, setRows] = useState([
    { itemDetail: '', annualQty: '', servepClean: '', rate: "", annualContractvalue: "", tax: '', amount: "", total: '', subTotal: '', discount: '' }
  ]);


  const addRow = (e) => {
    e.preventDefault()
    const newRows = [...rows, { itemDetail: '' }];
    setRows(newRows);
    setFormData(prev => ({ ...prev, itemtable: newRows }));
  };

  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader> Create Sales Order</DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme='pink' />}
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>
              <div className='card mt-2'>
                <div className='card-body'>
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <Select name='customerName'
                        options={companyData}
                        defaultValue={companyData?.find((item) => item.value === companyData?.companyOptions)}
                        value={companyData?.find((item) => item.value === formData?.companyOptions)}
                        onChange={(selectedOption) => {
                          setDataToItemTableRowCompany(selectedOption);
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            companyOptions: selectedOption ? selectedOption.value : '',
                            customerName: selectedOption ? selectedOption.value : '',
                          }));
                        }} styles={customStyle} />
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Customer Name</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Sales Order' name='salesOrder' value={formData?.salesOrder} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Sales Order</FormLabel>
                    </div>
                  </div>
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='reference' name='reference' value={formData?.reference} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Reference</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Sales Order Date' name='salesOrderDate' value={formData?.salesOrderDate} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Sales Order Date</FormLabel>
                    </div>
                  </div>
                  <div className='row '>

                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Expected Shipment Date' name='expectedShipmentDate' value={formData?.expectedShipmentDate} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Expected Shipment Date</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <select className=' rounded' name='workingDays' type='text' placeholder="Working Days" style={{ width: '100%', outline: 'none' }} value={formData?.workingDays} onChange={handleChange}  >
                          <option >Monday</option>
                          <option >Tuesday</option>
                          <option >Wednesday</option>
                          <option >Thrusday</option>
                          <option >Friday</option>
                          <option >Saturday</option>
                          <option >Sunday</option>
                        </select>
                      </div>
                      <FormLabel className="small-label ps-3">Working Days</FormLabel>
                    </div>
                  </div>
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <Select name='deliveryMethod' options={deliveryMethod} defaultValue={deliveryMethod.find((item) => (item.value === formData?.deliveryMethod))} onChange={(option) => { setFormData(prevFormData => ({ ...prevFormData, deliveryMethod: option.value })) }} styles={customStyle} />
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Delivery Method</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <Select name='salesPerson'
                        options={employeesData}
                        defaultValue={employeesData?.find((item) => item.value === employeesData?.employeesOptions)}
                        value={employeesData?.find((item) => item.value === formData?.employeesOptions)}
                        onChange={(selectedOption) => {
                          setDataToItemTableRowEmployees(selectedOption);
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            employeesOptions: selectedOption ? selectedOption.value : '',
                            salesPerson: selectedOption ? selectedOption.value : '',
                          }));
                        }} styles={customStyle} />
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "6px" }}>Sales Person</FormLabel>
                    </div>
                  </div>
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <Select
                        name="franchiseeAccount"
                        options={vendorData}
                        defaultValue={vendorData?.find((item) => item.value === vendorData?.vendorOptions)}
                        value={vendorData?.find((item) => item.value === formData?.vendorOptions)}
                        onChange={(vendorOptions) => {
                          setDataToItemTableRowVendor(vendorOptions);
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            vendorOptions: vendorOptions ? vendorOptions.value : '',
                            franchiseeAccount: vendorOptions ? vendorOptions.value : '',
                          }));
                        }}
                        styles={customStyle}
                      />
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Franchisee Account</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <select className=' rounded' name='paymentTerms' type='text' placeholder="Payment Terms" style={{ width: '100%', outline: 'none' }} value={formData?.paymentTerms} onChange={handleChange}  >
                          <option >Due On Receipt</option>
                          <option >Net 15</option>
                          <option >Net 30</option>
                          <option >Net 7</option>
                          <option >Net 60</option>
                          <option >Due end of the month</option>
                          <option >Due end of the next month</option>
                          <option >Custom</option>
                        </select>
                      </div>
                      <FormLabel className="small-label ps-3">Payment Terms</FormLabel>
                    </div>
                  </div>
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <select className=' rounded' type='text' placeholder="Frequency" name='frequency' style={{ width: '100%', outline: 'none' }} value={formData?.frequency} onChange={handleChange}  >
                          <option >Weekly</option>
                          <option >Monthly</option>
                          <option >Fornightly</option>
                          <option >one-off job</option>
                        </select>
                      </div>
                      <FormLabel className="small-label ps-3">Frequency</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='So Date' name='soDate' value={formData?.soDate} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "0px" }} >S/O Date</FormLabel>
                    </div>
                  </div>
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <select className=' rounded' name='jobType' type='text' placeholder="Job Type" style={{ width: '100%', outline: 'none' }} value={formData?.jobType} onChange={handleChange}  >
                          <option >Regular</option>
                          <option >one-off job</option>
                        </select>
                      </div>
                      <FormLabel className="small-label ps-3">Job Type</FormLabel>
                    </div>
                    <div className='col-lg-6'>
                      <div className='d-flex py-3'><span> <input class="form-check-input" type="checkbox" name='recurringSO' value={formData?.recurringSO} onChange={handleChange} />
                      </span><p className='ps-3'>Recurring SO </p></div>
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div className='col-lg-12'>
                      <Textarea rows='4' type='text' style={{ border: "1px solid grey" }} placeholder='Notes' name='customerNotes' value={formData?.customerNotes} onChange={handleChange} />
                      <FormLabel className="small-label">Customer Notes</FormLabel>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card mt-2'>
                <div className='card-body'>
                  <div className="w-100">
                    <div className="custom-scroll">
                      <table className="table-class">
                        <thead>
                          <tr>
                            <th colSpan={9}>
                              <h5 style={{ fontSize: '15px' }}>Item Table</h5>
                            </th>
                          </tr>
                          <tr className="border">
                            <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}> ACTION</th>
                            <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}>ITEM DETAILS  </th>
                            <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}>QTY </th>
                            <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}>RATE</th>
                            <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}> Discount</th>
                            <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}>TAX </th>
                            <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}> AMOUNT </th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows?.map((row, index) => (
                            <tr key={index}>
                              <td className="border text-center table-class">
                                <button onClick={() => deleteRow(index)} className="delete-button">
                                  <Trash2 size={16} color="#dd0b58" />
                                </button>
                              </td>
                              <td className="border table-class">
                                <div>
                                  <Select
                                    name="itemDetails"
                                    options={inventoryOptions}
                                    value={inventoryOptions.find((option) => option.value === row.rowId) || null}
                                    onChange={(option) => setDataToItemTableRow(option, index)}
                                    className="custom-select-container"
                                    classNamePrefix="custom-select"
                                  />
                                </div>
                              </td>
                              <td className="border table-class">
                                <input
                                  className="inputField"
                                  type="number"
                                  value={row.qty}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].qty = e.target.value;
                                    // Recalculate amount when qty or rate changes
                                    newRows[index].amount =
                                      newRows[index].qty * newRows[index].rate -
                                      (newRows[index].discount * (newRows[index].qty * newRows[index].rate)) / 100;
                                    setRows(newRows);
                                    setFormData((prev) => ({ ...prev, itemtable: newRows }));
                                  }}
                                />
                              </td>
                              <td className="border table-class">
                                <input
                                  className="inputField"
                                  type="number"
                                  value={row.rate}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].rate = e.target.value;
                                    // Recalculate amount when rate or qty changes
                                    newRows[index].amount =
                                      newRows[index].qty * newRows[index].rate -
                                      (newRows[index].discount * (newRows[index].qty * newRows[index].rate)) / 100;
                                    setRows(newRows);
                                    setFormData((prev) => ({ ...prev, itemtable: newRows }));
                                  }}
                                />
                              </td>
                              <td className="border table-class">
                                <input
                                  className="inputField"
                                  type="number"
                                  value={row.discount}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].discount = e.target.value;
                                    // Recalculate amount when discount changes
                                    newRows[index].amount =
                                      newRows[index].qty * newRows[index].rate -
                                      (newRows[index].discount * (newRows[index].qty * newRows[index].rate)) / 100;
                                    setRows(newRows);
                                    setFormData((prev) => ({ ...prev, itemtable: newRows }));
                                  }}
                                />
                              </td>
                              <td className="border table-class">
                                <input
                                  className="inputField"
                                  type="number"
                                  value={row.tax}
                                  onChange={(e) => {
                                    const newRows = [...rows];
                                    newRows[index].tax = e.target.value;

                                    // Recalculate the amount considering the tax
                                    const totalBeforeTax = newRows[index].qty * newRows[index].rate;
                                    const discountAmount = (newRows[index].discount / 100 || 0) * totalBeforeTax;
                                    const amountBeforeTax = totalBeforeTax - discountAmount;

                                    // Calculate tax amount
                                    const taxAmount = (amountBeforeTax * newRows[index].tax) / 100;

                                    // Final amount including tax
                                    newRows[index].amount = amountBeforeTax + taxAmount;

                                    setRows(newRows);
                                    setFormData((prev) => ({ ...prev, itemtable: newRows }));
                                  }}
                                />
                              </td>
                              <td className="border table-class">
                                <input
                                  className="inputField"
                                  type="number"
                                  value={row.amount}
                                  readOnly
                                />
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan={9}>
                              <div className="ps-4" onClick={addRow} style={{ textAlign: 'left' }}>
                                <input type="text" placeholder="+ Add row" style={{ outline: 'none' }} />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="row">
                      <div className="d-flex justify-content-end align-items-center w-100">
                        <div className="card mt-3" style={{ width: '50%', borderRadius: '6px' }}>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-lg-6"><b>Sub Total</b></div>
                              <div className="col-lg-6 text-end">
                                <p>
                                  <b>
                                    {rows.reduce((acc, row) => {
                                      const total = row.qty * row.rate;
                                      const discountAmount = (row.discount / 100) * total;
                                      const amountBeforeTax = total - discountAmount;
                                      const taxAmount = (amountBeforeTax * row.tax) / 100;
                                      return acc + amountBeforeTax + taxAmount;
                                    }, 0).toFixed(2)}
                                  </b>
                                </p>
                              </div>
                            </div>
                            <div className="row mt-2" style={{ borderTop: '1px solid #e5e5e5' }}>
                              <div className="col-lg-6 mt-2">
                                <p>
                                  <b>Total</b>
                                </p>
                              </div>
                              <div className="col-lg-6 text-end mt-2">
                                <b>
                                  {rows.reduce((acc, row) => {
                                    const total = row.qty * row.rate;
                                    const discountAmount = (row.discount / 100) * total;
                                    const amountBeforeTax = total - discountAmount;
                                    const taxAmount = (amountBeforeTax * row.tax) / 100;
                                    return acc + amountBeforeTax + taxAmount;
                                  }, 0).toFixed(2)}
                                </b>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div></div>
            </form>
          </DrawerBody>
          <center><DrawerFooter style={{ display: 'inline-block' }}>
            <div className='gap-3 d-flex'>
              <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                Cancel
              </button>
              <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
            </div>
          </DrawerFooter></center>
        </DrawerContent>
      </Drawer>
    </>
  )
}
export default SalesForm;

